export enum FramesQuantity {
  All = 0,
  ManyOnly = 1,
  OneOnly = 2
}
